import { EXPIRED_DATE } from "../types";

const initialState = {

  expiredDate: 0,
  loading: false,
};

export default function MangeExpiredDate(state = initialState, action) {
  console.log("In here status of expired" , action.payload)
  switch (action.type) {
    case EXPIRED_DATE:
      return {
        ...state,
        expiredDate: action.payload,
        loading: false,
      };
      
    
      
    default:
      return state;
  }
}
